/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Card, CardContent } from '@mui/material';
import cx from 'classnames';
import { isAndroidDevice, isIosDevice } from 'src/utils/device.util';
import useIsMobile from 'src/hooks/useIsMobile';
import END_POINT from '../../config/endpoints.constants';
import withoutAuth from '../../hoc/withoutAuth';
import AnonymousLayout from '../AnonymousLayout';
import SEO from '../common/SEO';
import Button from '../common/Button';
import { useToast } from '../../context/ToastContext';
import { getErrorMessage } from '../../lib/error-handling';
import { SITE_DESCRIPTION } from '../../config/seo.constants';
// import Messages from '../../config/messages.constants';
import PasswordField from '../common/PasswordField';
import regionConfig from '../../config';
import PasswordChecklistTooltip, {
    MobileChecklistTooltip,
    PasswordInstructions,
} from '../PasswordChecklistTooltip';
import { isPasswordValid } from '../../validation/password.schema';

const StyledResetPassword = styled.div`
    @media (max-width: 768px) {
        height: auto;
        margin-bottom: 105px;
    }
    .reset-password-card {
        // width: 450px;
    }
    .password-sent-card {
        width: 500px;
    }
    .reset-password-content {
        display: flex;
        justify-conetnt: space-between;
        gap: 24px;
    }
    .reset-password-form {
    }
    .reset-password-checklist {
        margin-top: 4rem;
    }
    .heading {
        font-size: 32px;
        font-weight: 700;
    }
    .instructions {
        font-size: 16px;
        font-weight: 600;
        color: var(--black-60, rgba(17, 17, 17, 0.6));
    }
`;

const ResetPassword = () => {
    const toast = useToast();
    const navigate = useNavigate();
    const location = useLocation();
    // const user = useUser();
    const [isPasswordModified, setPasswordModified] = useState(false);
    const { register, handleSubmit } = useForm({
        defaultValues: {
            newPassword: '',
            repeatNewPassword: '',
        },
    });
    const [resetPasswordDetails, setResetPasswordDetails] = useState({
        newPassword: '',
        repeatNewPassword: '',
    });
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);

    const isMobile = useIsMobile();

    useEffect(() => {
        setIsButtonEnabled(
            isPasswordValid(resetPasswordDetails.newPassword) &&
                resetPasswordDetails.newPassword === resetPasswordDetails.repeatNewPassword,
        );
    }, [resetPasswordDetails]);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setResetPasswordDetails({ ...resetPasswordDetails, [name]: value });
    };

    const onSubmit = handleSubmit(async (data) => {
        // productAction('initiate_reset_password', SnowPlowUtil.getUserInfo(user));
        if (data.newPassword !== data.repeatNewPassword) {
            toast.error('New Password and Repeat new Password do not match');
            return;
        }
        const queryParams = new URLSearchParams(location.search);
        const resetPasswordData = { ...data, token: queryParams.get('token') };
        await axios
            .post(END_POINT.NEWPWD, resetPasswordData, {
                headers: {
                    'App-Name': 'userapp',
                    'App-Source': 'userapp',
                },
            })
            .then((res: any) => {
                if (res.data.code === 0) {
                    setPasswordModified(true);
                }
            })
            .catch((err) => {
                toast.error(getErrorMessage(err));
            });
    });

    const handleRedirect = () => {
        if (isIosDevice()) {
            window.location.href = regionConfig.iosLink;
        } else if (isAndroidDevice()) {
            window.location.href = regionConfig.androidLink;
        } else {
            navigate('/login', { replace: true });
        }
    };

    const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <AnonymousLayout isLoginScreen>
            <SEO
                title="Reset Password"
                description={`${regionConfig.appName} Reset Password - ${SITE_DESCRIPTION}`}
            />
            <StyledResetPassword className="w-full h-auto mt-32 flex justify-center items-center">
                <Card className={cx('reset-password-card card')}>
                    <CardContent>
                        {!isPasswordModified && (
                            <div className="reset-password-content">
                                <div className="reset-password-form">
                                    <div className="heading mb-8">Set your password</div>
                                    <form onSubmit={onSubmit}>
                                        <PasswordChecklistTooltip
                                            resetPasswordDetails={resetPasswordDetails}
                                        >
                                            <PasswordField
                                                allowPasswordToggle
                                                label="Password"
                                                inputRef={register}
                                                id="newPassword"
                                                type="password"
                                                name="newPassword"
                                                autoComplete="new-password"
                                                placeholder="Enter your password"
                                                onChange={handleChange}
                                                aria-required="true"
                                                ariaLabel="New Password"
                                                onClick={handleClick}
                                            />
                                        </PasswordChecklistTooltip>

                                        {isMobile && (
                                            <MobileChecklistTooltip
                                                id={id}
                                                open={open}
                                                anchorEl={anchorEl}
                                                onClose={handleClose}
                                                disableAutoFocus
                                                disableEnforceFocus
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'center',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'center',
                                                }}
                                                PaperProps={{
                                                    style: {
                                                        marginTop: -30, // move it up by 8px
                                                    },
                                                }}
                                            >
                                                <PasswordInstructions
                                                    resetPasswordDetails={resetPasswordDetails}
                                                />
                                            </MobileChecklistTooltip>
                                        )}
                                        <PasswordChecklistTooltip
                                            resetPasswordDetails={resetPasswordDetails}
                                        >
                                            <PasswordField
                                                allowPasswordToggle
                                                label="Confirm Password"
                                                inputRef={register}
                                                id="repeatNewPassword"
                                                type="password"
                                                name="repeatNewPassword"
                                                autoComplete="new-password"
                                                placeholder="Repeat your password"
                                                onChange={handleChange}
                                                aria-required="true"
                                                ariaLabel="Repeat New Password"
                                                onClick={handleClick}
                                            />
                                        </PasswordChecklistTooltip>

                                        {/* <p className="text-sm">{Messages.PASSWORD_INFO}</p> */}
                                        <Button
                                            type="submit"
                                            fullWidth
                                            size="large"
                                            disabled={!isButtonEnabled}
                                            aria-label="Set Password"
                                            className="normal-case source-sans-pro-font"
                                        >
                                            Save password
                                        </Button>
                                    </form>
                                </div>
                            </div>
                        )}
                        {isPasswordModified && (
                            <div>
                                <div className="mb-8">
                                    <div className="heading ">Your password has been set!</div>
                                    <div className="instructions">
                                        You can now log in with your new password.
                                    </div>
                                </div>
                                <Button
                                    type="button"
                                    onClick={handleRedirect}
                                    fullWidth
                                    size="large"
                                    aria-label="Return To Login"
                                    className="primary-bg-color normal-case source-sans-pro-font"
                                >
                                    Go back to Login
                                </Button>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </StyledResetPassword>
        </AnonymousLayout>
    );
};

export default withoutAuth(ResetPassword);
